/* 订单计划 */
<template>
  <div id="orderPlan" class="q-pa-md q-gutter-sm">
    <PageHeader content="打印筒标签" />

    <el-form :inline="true" class="demo-form-inline">
      <el-row>
        <el-form-item label="标签个数">
          <el-input
            v-model.number="form.labelCount"
            placeholder="标签个数"
          ></el-input>
        </el-form-item>
        <el-form-item label="每行个数">
          <el-input
            v-model.number="form.labelColume"
            placeholder="每行个数"
          ></el-input>
        </el-form-item>
        <el-form-item label="每页行数">
          <el-input
            v-model.number="form.labelRow"
            placeholder="每页行数"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="页面边距">
          <el-input
            v-model.number="form.padding"
            placeholder="设置页面边距(单位mm)"
          ></el-input>
        </el-form-item>
        <el-form-item label="表格边框">
          <el-input
            v-model="form.tableBorder"
            placeholder="设置表格边框(单位mm)"
          ></el-input>
        </el-form-item>
        <el-form-item label="首列宽度%">
          <el-input
            v-model.number="form.firstColWidth"
            placeholder="首列宽度%"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-button size="mini" @click="addLabel">添加</el-button>
      </el-row>
      <el-row v-for="(item, index) in label" :key="index">
        <el-form-item :label="'label' + index">
          <el-input v-model="item.key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item :label="'value' + index">
          <el-input v-model="item.value" placeholder="内容"></el-input>
        </el-form-item>
        <el-form-item v-if="label.length > 1">
          <el-button size="mini" @click="delLabel(index)">删除</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <button v-print="'#printTest'">
      <i class="el-icon-printer"></i>
    </button>

    <section id="printTest" class="page-a4" v-bind:style="getPageStyle">
      <table
        v-for="(item, index) in form.labelCount"
        :key="index"
        v-bind:style="getTableStyle"
      >
        <tr v-for="item in label" :key="item.key">
          <td align="center" v-bind:style="getColStyle">{{ item.key }}</td>
          <td align="center">{{ item.value }}</td>
        </tr>
      </table>
    </section>
  </div>
</template>



<style scoped>
@import url("../styles/print.css");
table {
  float: left;
  border: 0;
}
</style>

<script>
import PageHeader from "../components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      label: [
        { key: "纱支", value: "" },
        { key: "色号", value: "" },
        { key: "批号", value: "" },
      ],
      form: {
        labelCount: 60,
        labelColume: 5,
        labelRow: 12,
        firstColWidth: 25,
        padding: 4,
        tableBorder: 0.5,
      },
    };
  },
  computed: {
    getTableStyle: function () {
      return {
        width:
          parseInt((210 - this.form.padding * 2) / this.form.labelColume) +
          "mm",
        height:
          parseInt((297 - this.form.padding * 2) / this.form.labelRow) + "mm",
        border: this.form.tableBorder + "mm solid",
        "border-collapse": "collapse",
        "border-spacing": 0,
        "table-layout": "fixed",
      };
    },
    getColStyle() {
      return {
        width: this.form.firstColWidth + "%",
      };
    },
    getPageStyle() {
      return {
        padding: this.form.padding + "mm",
        display: "flex",
        "flex-direction": "row",
        "flex-wrap": "wrap",
        "align-content": "flex-start",
        "justify-content": "flex-start",
      };
    },
  },
  methods: {
    addLabel() {
      this.label.push({ key: "", value: "" });
    },
    delLabel(index) {
      this.label.splice(index, 1);
    },
  },
  mounted(){
    this.label[0].value = this.$route.query.yarn;
    this.label[1].value = this.$route.query.color;
    this.label[2].value = this.$route.query.batchNo;
  }
};
</script>

<style scoped>
#printTest table td {
  border: 1px solid;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
